
export enum DoorMatchCd {
	AREA = 'Area',
	TRAILER = 'Trailer'}
